import { useContext, useMemo } from 'react'

import { AuthContext } from 'providers'

export const useAuth = () => {
    const auth = useContext(AuthContext)

    return useMemo(() => auth, [auth])
}
